// @ts-nocheck
import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEventListener } from "usehooks-ts";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CREATE_ERP_ADDRESS_BOOK_MASTER,
  CreateCustomerAccount,
  EDIT_ERP_ADDRESS_BOOK_MASTER,
  GetERPAddressBookDataByID,
  GetGSTDetailsByGSTNo,
  MERGE_ADDRESS_BOOK,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { Confirm } from "../../Confirmation/Confirm";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import { ERPAddressBookMasterConfig } from "./AddERPAddressBookMasterConfig";
import { handleFormReset, updateSingleField, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { GiConsoleController } from "react-icons/gi";
import "./AddERPAddressBookMaster.scss";
import GetGSTINDetailsModal from "./GetGSTINDetailsModal";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";

export const AddERPAddressBookMaster = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  ReferenceFieldName = [],
  ReferFormKey = "",
}: {
  show: boolean;
  TypeOfPortal: string;
  submitType: string;
  ParentPortalCloseFunction: () => void;
  ReferenceFieldName?: any;
  ReferFormKey?: string;
}) => {
  const Form_Key = TypeOfPortal === "Merge" ? "Merge_ERP_Address_Book_Master" : "ERP_Address_Book_Master";
  const formRef = useRef({});
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [FormData, setFormdata] = useState<any>({});
  const { pushModal, popModal, getTopModal } = useModalContext();
  const [toggle, settoggle] = useState(show ? show : false);
  const [ConfirmMerge, SetConfirmMerge] = useState(false);
  const dispatch = useDispatch();
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const [field, setFields] = useState<any>([]);
  const [alldata, setalldata] = useState({});
  const [GSTModalToggle, setGSTModalToggle] = useState(false);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.ERP_Address_Book_Master?.Selected_Row;
  const [selectedRows, setSelectedRows] = useState([]);
  const [formErrors, setFormErrors] = useState<any>({});
  const [allFieldsData, setAllFieldsData] = useState({});
  const [initialData,setInitialData]=useState({})
  const {isDisabled}=useIsDisabled({TypeOfPortal,initial:initialData, current:FormData});


  // Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [getDataById, { loading: getDataByIdLoader }] = useLazyQuery(GetERPAddressBookDataByID, {
    fetchPolicy: "network-only",
  });
  const [getGSTDetailsByNo, { loading: getGSTDetailsByNoLoader }] = useLazyQuery(GetGSTDetailsByGSTNo, {
    fetchPolicy: "network-only",
  });

  const [EditingData, { loading: editAddressBookMasterLoading }] = useMutation(EDIT_ERP_ADDRESS_BOOK_MASTER);
  const [CreatingData, { loading: createAddressBookMasterLoading }] = useMutation(CREATE_ERP_ADDRESS_BOOK_MASTER);
  const [MergingData, { loading: mergeCityLoading }] = useMutation(MERGE_ADDRESS_BOOK);

  const PackagingMasterLoadingState =
    createAddressBookMasterLoading || editAddressBookMasterLoading || getDataByIdLoader;

    const HanldeChangeonForm = (values) => {
      setFormdata(prev=>{
        const next = {...prev,...values};
        if(!isFirstLoad){
          setInitialData(next)
        }
        return next
      })
    };
  

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  let fillGSTField = (Name, Pincode, GSTIN, paraddr) => {
    updateSingleField(formRef, "Name", Name);
    updateSingleField(formRef, "Pincode", Pincode);
    updateSingleField(formRef, "GST_Number", GSTIN);
    updateSingleField(formRef, "Address_Line_1", paraddr);
  };

  // "33AANCS2882A1ZG"
  // useEffect(() => {
  //   if (FormData?.GST_Number && FormData?.Fill_Details_By_GSTIN && validateGST(FormData?.GST_Number)) {
  //     getGSTDetailsByNo({ variables: { gstNo: FormData?.GST_Number } }).then((res) => {
  //       console.log(res?.data?.getGSTDetailsByGSTNo);
  //       let GSTData = res?.data?.getGSTDetailsByGSTNo;
  //       if (GSTData?.lgnm) {
  //         updateSingleField(formRef, "Name", GSTData?.lgnm);
  //       }
  //       if (GSTData?.pradr?.addr?.pncd) {
  //         updateSingleField(formRef, "Pincode", GSTData?.pradr?.addr?.pncd);
  //       }
  //     });
  //   }
  // }, [FormData?.GST_Number, FormData?.Fill_Details_By_GSTIN]);

  // useEffect(() => {
  //   if (allFieldsData?.Is_Bill_Account_Created) {
  //     const inputNames = ["Add_Bill_Account", "Bill_Account"];

  //     inputNames.forEach((name) => {
  //       const input = document.getElementsByName(name);

  //       if (input.length > 0) {
  //         const lastInput = input[input.length - 1] as HTMLInputElement;

  //         lastInput.disabled = true;
  //       }
  //     });
  //   }
  // }, [allFieldsData?.Is_Bill_Account_Created]);

  useEffect(() => {
    if (inputFields?.length && TypeOfPortal == "Add") {
      setFields(inputFields);
    } else if (inputFields?.length && (TypeOfPortal == "Edit" || TypeOfPortal == "View" || TypeOfPortal == "Merge")) {
      // console.log(inputFields, "inputFields");
      let fieldData = inputFields.map((e) => {
        let newFields = e.fields?.filter((el) => el.name !== "Add_Bill_Account");
        return {
          ...e,
          fields: newFields,
        };
      });
      setFields(fieldData);
    }
  }, [inputFields]);

  useEffect(() => {
    if (FormData?.Add_Bill_Account && TypeOfPortal == "Add") {
      const inputNames = ["Bill_Account"];

      inputNames.forEach((name) => {
        const input = document.getElementsByName(name);

        if (input.length > 0) {
          const lastInput = input[input.length - 1] as HTMLInputElement;

          lastInput.disabled = true;
        }
      });
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            Bill_Account: {},
          },
        },
      });
      updateSingleField(formRef, "Bill_Account", "");
    } else if (!FormData?.Add_Bill_Account && TypeOfPortal == "Add") {
      const inputNames = ["Bill_Account"];

      inputNames.forEach((name) => {
        const input = document.getElementsByName(name);

        if (input.length > 0) {
          const lastInput = input[input.length - 1] as HTMLInputElement;

          lastInput.disabled = false;
        }
      });
    }
  }, [FormData?.Add_Bill_Account]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.ERP_Address_Book_Master?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (field?.length) {
      if (TypeOfPortal !== "Add") {
        // getFormSectionAndFields().then(() => {
        getDataById({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          let PartData = { ...data?.ERPAddressBookByID };

          if (TypeOfPortal == "Merge") {
            dispatch({
              type: "StoreMasterData",
              payload: {
                formkey: Form_Key,
                data: {
                  Select_Address: PartData,
                },
              },
            });
            updateValueForm(formRef, { Select_Address: PartData?.Name });
          } else {
            dispatch({
              type: "StoreMasterData",
              payload: {
                formkey: Form_Key,
                data: {
                  Bill_Account: PartData?.Bill_Account_Data,
                },
              },
            });
            PartData.Bill_Account = PartData?.Bill_Account_Data?.Search_Value;
            setAllFieldsData(PartData);
            updateValueForm(formRef, PartData);
          }
        });
        // });
      } else {
        updateValueForm(formRef, {
          Add_Bill_Account: false,
        });
      }
    }
  }, [fielddata, field]);

  // This code snippet dynamically manages CRUD (Create, Read, Update, Delete) for Brief Understanding Refer MD Documentation in FormComponents,
  const { executeOperation }: { executeOperation: any } = useSubmitOperation();
  const operationType = TypeOfPortal;
  if (operationType === "Merge") {
    FormData.existingId = FormDataFromRedux?.MasterData[Form_Key]?.Select_Address?._id;
    FormData.newId = FormDataFromRedux?.MasterData[Form_Key]?.Merge_Address_With?._id;
  }
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, FormData, selectedRows);

  const MutationFunctions = {
    CreatingData,
    EditingData,
    MergingData,
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    ClearSpecificForm(dispatch, Form_Key);
  };

  const submit = async (closeAction) => {
    FormData.Contact_Number = FormData.Contact_Number ? String(FormData.Contact_Number) : "";
    if (FormData?.Add_Bill_Account) {
      FormData.Is_Bill_Account_Created = true;
    }
    FormData.Bill_Account = FormDataFromRedux.MasterData[Form_Key]?.Bill_Account?._id;
    let Name = ReferenceFieldName[0]?.name;
    const mutationFunction = getMutationFunction(operationType, MutationFunctions);
    console.log(variables, "variables");
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: FormData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        PageName: Form_Key,
        OnSuccess: (res: any) => {
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data: {
                [Name]: res?.data?.createERPAddressBook || res?.data?.editERPAddressBook,
              },
            },
          });
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => handleFormReset(formRef),
      onSuccess: () => {},
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const ConfirmModalOpen = () => {
    SetConfirmMerge(true);
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={isDisabled}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => Validate_handleSubmit(SaveAndCloseForAdd)
          : TypeOfPortal === "Merge"
          ? () => ConfirmModalOpen()
          : () => Validate_handleSubmit(submit)
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={PackagingMasterLoadingState}
    />
  );

  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={TypeOfPortal + " Address Book"}
        >
          {PackagingMasterLoadingState && <div className="loader-line-div" />}

          <div className="formContainer">
            {field && field?.length > 0 ? (
              field?.map((e) => (
                <div key={e.id} className="FormSectionParent">
                  <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                  <div className="FormSection insidecontainer">
                    {TypeOfPortal === "Add" && (
                      <div className="GSTDetailsModal" onClick={() => setGSTModalToggle(true)}>
                        + Add Details By GSTIN
                      </div>
                    )}

                    <FormInputSectionComponent
                      inputfields={e.fields}
                      Type={e.name}
                      TypeOfPortal={TypeOfPortal}
                      onErrorsChange={handleErrorsChange}
                      formkey={Form_Key}
                      onhandleFormikChange={HanldeChangeonForm}
                      formRef={formRef}
                      setFirstLoad={setFirstLoad}
                    />
                  </div>
                </div>
              ))
            ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
              <p>No form fields available.</p>
            ) : null}
          </div>
        </Reactportal>
      </div>
      {GSTModalToggle && (
        <GetGSTINDetailsModal
          toggle={GSTModalToggle}
          setToggle={() => setGSTModalToggle(false)}
          fillGSTField={(name, pincode, gst, paraddr) => fillGSTField(name, pincode, gst, paraddr)}
        />
      )}
      {ConfirmMerge && (
        <Confirm
          submit={submit}
          settoggle={SetConfirmMerge}
          toggle={ConfirmMerge}
          loadingState={mergeCityLoading}
          submitType={"Confirm Merge"}
          TypeOfPortal={"Confirm"}
        />
      )}
    </>
  );
};
